{
  "name": "简体中文",
  "code": "zh-CN",
  "messages": {
    "alert": {
      "title": "确认",
      "confirm": "确定",
      "cancel": "取消"
    },
    "autocomplete": {
      "clear": "清除",
      "loading": "加载中…",
      "noResult": "无匹配项"
    },
    "avatar": {
      "unknownUser": "未知用户"
    },
    "avatarGroup": {
      "label": "{count} 位用户"
    },
    "carousel": {
      "label": "轮播",
      "prev": "上一张",
      "next": "下一张",
      "nav": "轮播导航",
      "goto": "跳到第 {index} 张"
    },
    "chip": {
      "remove": "移除"
    },
    "commandPalette": {
      "placeholder": "搜索…",
      "empty": "输入关键字搜索",
      "noResult": "无结果",
      "loading": "加载中…",
      "close": "关闭",
      "hintSelect": "选择",
      "hintOpen": "打开",
      "hintClose": "关闭",
      "resultCount": "{count} 条结果"
    },
    "copy": {
      "copied": "已复制",
      "success": "{text} 复制成功",
      "failure": "{text} 复制失败! 请更换更现代的浏览器!"
    },
    "datePicker": {
      "placeholderDay": "请选择日期",
      "placeholderMonth": "请选择月份",
      "placeholderYear": "请选择年份",
      "clear": "清空",
      "today": "今天",
      "close": "关闭",
      "prevYear": "上一年",
      "nextYear": "下一年",
      "prevPage": "上一{unit}",
      "nextPage": "下一{unit}",
      "zoomOut": "{label} — 返回上一级",
      "unitMonth": "月",
      "unitYear": "年",
      "unitDecade": "个十年",
      "monthCell": "{year}年{month}"
    },
    "drawer": {
      "close": "关闭抽屉"
    },
    "fileInput": {
      "trigger": "选择文件",
      "selected": "已选 {count} 个文件"
    },
    "filePicker": {
      "tooLarge": "{name} 超过大小限制 ({size})"
    },
    "input": {
      "clear": "清除",
      "reveal": "显示密码",
      "hide": "隐藏密码"
    },
    "lightbox": {
      "label": "图片查看器",
      "close": "关闭",
      "prev": "上一张",
      "next": "下一张",
      "goto": "跳转到第 {index} 张",
      "zoomIn": "放大",
      "zoomOut": "缩小",
      "rotateLeft": "向左旋转 90°",
      "rotateRight": "向右旋转 90°",
      "reset": "重置缩放/旋转/位置",
      "download": "下载"
    },
    "lightboxGallery": {
      "view": "查看大图"
    },
    "loading": {
      "description": "正在摸鱼中...咕咕咕"
    },
    "loli": {
      "close": "关闭"
    },
    "message": {
      "close": "关闭"
    },
    "modal": {
      "close": "关闭"
    },
    "null": {
      "description": "莲说这里什么都没有"
    },
    "numberInput": {
      "decrement": "减少",
      "increment": "增加"
    },
    "pagination": {
      "nav": "分页导航",
      "prev": "上一页",
      "next": "下一页",
      "page": "第 {page} 页",
      "hintBefore": "您可以使用",
      "hintAfter": "来进行快速翻页",
      "jumpLabel": "跳转到页数",
      "jump": "跳转"
    },
    "pinInput": {
      "label": "验证码",
      "digit": "{label} 第 {index} 位"
    },
    "reaction": {
      "label": "点赞"
    },
    "select": {
      "searchPlaceholder": "搜索…",
      "noResult": "无匹配项",
      "loading": "加载中…",
      "clear": "清除",
      "removeOption": "移除 {label}"
    },
    "spoiler": {
      "copyCode": "复制代码",
      "reveal": "剧透内容,点击或按回车显示"
    },
    "tagInput": {
      "tag": "标签 {tag}",
      "removeTag": "移除标签 {tag}"
    },
    "upload": {
      "imageAlt": "上传图片",
      "cropTitle": "裁剪图片",
      "cancel": "取消",
      "confirm": "确定"
    }
  }
}
